// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2WH7w","savePackageButton":"ClientWallet_savePackageButton__2Sh7v"};